import { Tag, TagLabel } from '@chakra-ui/react';
import React from 'react';

import { TagIcon } from 'packages/common-frontend/components/icons';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';

export const SavingStatusTag = () => {
  const savingState = useCreditAgreementStore((store) => {
    if (store.isSaving) return 'saving';
    if (store.isCreditAgreementDirty) return 'dirty';
    return 'saved';
  });

  switch (savingState) {
    case 'dirty':
      return (
        <Tag variant="solid-muted" colorScheme="orange">
          <TagIcon icon="pencil" size="md" />
          <TagLabel>Draft: Unsaved</TagLabel>
        </Tag>
      );
    case 'saving':
      return (
        <Tag variant="solid-muted" colorScheme="orange">
          <TagIcon
            icon="spinner-scale"
            size="md"
            style={{
              animation: '2s linear infinite spin',
              transformOrigin: 'center',
            }}
          />
          <TagLabel>Draft: Saving...</TagLabel>
        </Tag>
      );
    case 'saved':
      return (
        <Tag variant="solid-muted" colorScheme="blue">
          <TagIcon icon="circle-check" size="md" />
          <TagLabel>Draft: Saved</TagLabel>
        </Tag>
      );
    default:
      return null;
  }
};
